import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Link from 'next/link';

import { ICurrentCity } from '@r1-frontend/entities/City/models/ICurrentCity';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { openCitySelect } from '~/src/components/CitySelectContainer/store/actionCreators';
import { getCurrentCity } from '~/src/store/selectors/city';
import LogoDefault from '~/static/images/menu/logo_default.svg';
import MobileLogoDefault from '~/static/images/menu/mobile_logo_default.svg';

import * as ST from './styled';

export const Billet: React.FC = () => {
    const dispatch = useDispatch();
    const isMobile = useMatchMedia('(max-width: 450px)');
    const onCityChange = useCallback(() => {
        dispatch(openCitySelect());
    }, [dispatch]);
    const currentCity: ICurrentCity = useSelector(getCurrentCity);
    const mobileLogoImg = currentCity.logo ? currentCity.logo_narrow : MobileLogoDefault;

    return (
        <ST.RowBlock middle='sm' top='xs' start='xs'>
            <ST.Col sm={1}>
                <Link href='/' passHref>
                    <a>
                        <ST.Logo alt={'Логотип Дом.ру'} src={isMobile ? mobileLogoImg : LogoDefault} data-test={'logo'}/>
                    </a>
                </Link>
            </ST.Col>
            <ST.ColCity xsOffset={1} xs={7} smOffset={0} sm={11}>
                <ST.Row between='sm'>
                    <ST.ColCityWrap xs={12} sm={4}>
                        <ST.CitySelect
                            data-test={'select'}
                            onClick={onCityChange}
                        >
                            {currentCity?.name}
                        </ST.CitySelect>
                    </ST.ColCityWrap>
                    {
                        currentCity?.phone && (
                            <ST.ColPhoneWrap xs={12} sm={4} data-test={'phone'}>
                                <ST.WrapperPhone>
                                    <ST.Phone
                                        href={`tel:+${currentCity?.phone?.replace(/\D/g, '')}`}
                                        className='js-calltouch-phone'
                                    >
                                        {currentCity?.phone}
                                    </ST.Phone>
                                </ST.WrapperPhone>
                            </ST.ColPhoneWrap>
                        )
                    }
                </ST.Row>
            </ST.ColCity>
        </ST.RowBlock>
    );
};

export default Billet;
